import { useEffect, useState } from 'react';

/**
 * `value`, once it has stopped changing for `delay` ms. Server searches key
 * their query on this, so typing "alice" sends one request rather than five,
 * while the field itself (and the URL) still follows every keystroke.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return settled;
}
